import { CheckCircleFilled, ExclamationCircleFilled } from "@ant-design/icons";
import React from "react";
import styled from "styled-components";

import { COLORS } from "../constants";

import { Tag } from ".";

const StyledTag = styled(Tag)`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  border: none;
  padding: 2px 8px;
  margin: 0;

  && .text {
    color: ${COLORS.black85};
    white-space: nowrap;
    margin-left: 5px;
  }

  svg {
    height: 12px;
    width: 12px;
  }
`;

type Props = {
  status: "failed" | "warning" | "ok";
  label?: React.ReactNode;
};

export const StatusTag: React.FC<Props> = ({ status, label }) => {
  return (
    <StyledTag color={status === "warning" ? "orange" : status === "ok" ? "green" : "red"}>
      {status !== "ok" ? <ExclamationCircleFilled /> : <CheckCircleFilled />}

      <span className="text">
        {label ? label : status === "warning" ? "Warning" : status === "ok" ? "OK" : "Failed"}
      </span>
    </StyledTag>
  );
};
